import Modal from './modal';
import ModuleBox from './ModuleBox';
import RedHot from './RedHot';
import Tag from './Tag';
import Lottery from './Lottery/index';
import Lottery2 from './Lottery/index2.vue';
import Message from './Message';
import MessageTag from './MessageTag';
import CoinTag from './CoinTag';
import Progress from './Progress';
import NumRed from './NumRed';
import Toast from './Toast';
import BalanceTag from './BalanceTag';
import MarqueeGlobal from './Marquee';
import SymbolIcon from './SymbolIcon';

const GlobalComponent = {
	install(Vue) {
		Vue.component('Modal', Modal);
		Vue.component('ModuleBox', ModuleBox);
		Vue.component('RedHot', RedHot);
		Vue.component('Tag', Tag);
		Vue.component('Lottery', Lottery);
		Vue.component('Lottery2', Lottery2);
		Vue.component('Message', Message);
		Vue.component('MessageTag', MessageTag);
		Vue.component('CoinTag', CoinTag);
		Vue.component('Progress', Progress);
		Vue.component('NumRed', NumRed);
		Vue.component('Toast', Toast);
		Vue.component('BalanceTag', BalanceTag);
		Vue.component('MarqueeGlobal', MarqueeGlobal);
		Vue.component('SymbolIcon', SymbolIcon);
	},
};
export default GlobalComponent;



// WEBPACK FOOTER //
// ./src/components/common/index.js